"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc777Factory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var Erc777Factory = /** @class */ (function (_super) {
    __extends(Erc777Factory, _super);
    function Erc777Factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    Erc777Factory.prototype.deploy = function (name_, symbol_, defaultOperators_, overrides) {
        return _super.prototype.deploy.call(this, name_, symbol_, defaultOperators_, overrides || {});
    };
    Erc777Factory.prototype.getDeployTransaction = function (name_, symbol_, defaultOperators_, overrides) {
        return _super.prototype.getDeployTransaction.call(this, name_, symbol_, defaultOperators_, overrides || {});
    };
    Erc777Factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    Erc777Factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    Erc777Factory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return Erc777Factory;
}(contracts_1.ContractFactory));
exports.Erc777Factory = Erc777Factory;
var _abi = [
    {
        inputs: [
            {
                internalType: 'string',
                name: 'name_',
                type: 'string',
            },
            {
                internalType: 'string',
                name: 'symbol_',
                type: 'string',
            },
            {
                internalType: 'address[]',
                name: 'defaultOperators_',
                type: 'address[]',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'tokenHolder',
                type: 'address',
            },
        ],
        name: 'AuthorizedOperator',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'operatorData',
                type: 'bytes',
            },
        ],
        name: 'Burned',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'operatorData',
                type: 'bytes',
            },
        ],
        name: 'Minted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'tokenHolder',
                type: 'address',
            },
        ],
        name: 'RevokedOperator',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'operatorData',
                type: 'bytes',
            },
        ],
        name: 'Sent',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Transfer',
        type: 'event',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'holder',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
        ],
        name: 'allowance',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'approve',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
        ],
        name: 'authorizeOperator',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'tokenHolder',
                type: 'address',
            },
        ],
        name: 'balanceOf',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'burn',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'decimals',
        outputs: [
            {
                internalType: 'uint8',
                name: '',
                type: 'uint8',
            },
        ],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [],
        name: 'defaultOperators',
        outputs: [
            {
                internalType: 'address[]',
                name: '',
                type: 'address[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'granularity',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'tokenHolder',
                type: 'address',
            },
        ],
        name: 'isOperatorFor',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'name',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
            {
                internalType: 'bytes',
                name: 'operatorData',
                type: 'bytes',
            },
        ],
        name: 'operatorBurn',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'recipient',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
            {
                internalType: 'bytes',
                name: 'operatorData',
                type: 'bytes',
            },
        ],
        name: 'operatorSend',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
        ],
        name: 'revokeOperator',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'recipient',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'send',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'symbol',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalSupply',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'recipient',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'transfer',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'holder',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'recipient',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'transferFrom',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
var _bytecode = '0x60806040523480156200001157600080fd5b50604051620023ef380380620023ef833981810160405260608110156200003757600080fd5b81019080805160405193929190846401000000008211156200005857600080fd5b9083019060208201858111156200006e57600080fd5b82516401000000008111828201881017156200008957600080fd5b82525081516020918201929091019080838360005b83811015620000b85781810151838201526020016200009e565b50505050905090810190601f168015620000e65780820380516001836020036101000a031916815260200191505b50604052602001805160405193929190846401000000008211156200010a57600080fd5b9083019060208201858111156200012057600080fd5b82516401000000008111828201881017156200013b57600080fd5b82525081516020918201929091019080838360005b838110156200016a57818101518382015260200162000150565b50505050905090810190601f168015620001985780820380516001836020036101000a031916815260200191505b5060405260200180516040519392919084640100000000821115620001bc57600080fd5b908301906020820185811115620001d257600080fd5b8251866020820283011164010000000082111715620001f057600080fd5b82525081516020918201928201910280838360005b838110156200021f57818101518382015260200162000205565b5050505091909101604052505084516200024392506002915060208601906200040b565b508151620002599060039060208501906200040b565b5080516200026f906004906020840190620004a0565b5060005b600454811015620002cf57600160056000600484815481106200029257fe5b6000918252602080832091909101546001600160a01b031683528201929092526040019020805460ff191691151591909117905560010162000273565b50604080516329965a1d60e01b815230600482018190527fac7fbab5f54a3ca8194167523c6753bfeb96a445279294b6125b68cce2177054602483015260448201529051731820a4b7618bde71dce8cdc73aab6c95905fad24916329965a1d91606480830192600092919082900301818387803b1580156200035057600080fd5b505af115801562000365573d6000803e3d6000fd5b5050604080516329965a1d60e01b815230600482018190527faea199e31a596269b42cdafd93407f14436db6e4cad65417994c2eb37381e05a602483015260448201529051731820a4b7618bde71dce8cdc73aab6c95905fad2493506329965a1d9250606480830192600092919082900301818387803b158015620003e957600080fd5b505af1158015620003fe573d6000803e3d6000fd5b505050505050506200050f565b828054600181600116156101000203166002900490600052602060002090601f0160209004810192826200044357600085556200048e565b82601f106200045e57805160ff19168380011785556200048e565b828001600101855582156200048e579182015b828111156200048e57825182559160200191906001019062000471565b506200049c929150620004f8565b5090565b8280548282559060005260206000209081019282156200048e579160200282015b828111156200048e57825182546001600160a01b0319166001600160a01b03909116178255602090920191600190910190620004c1565b5b808211156200049c5760008155600101620004f9565b611ed0806200051f6000396000f3fe608060405234801561001057600080fd5b50600436106101365760003560e01c8063959b8c3f116100b2578063d95b637111610081578063fad8b32a11610066578063fad8b32a146105ac578063fc673c4f146105d2578063fe9d93031461071457610136565b8063d95b637114610550578063dd62ed3e1461057e57610136565b8063959b8c3f1461043b57806395d89b41146104615780639bd9bbc614610469578063a9059cbb1461052457610136565b806323b872dd11610109578063556f0dc7116100ee578063556f0dc7146102be57806362ad1b83146102c657806370a082311461041557610136565b806323b872dd1461026a578063313ce567146102a057610136565b806306e485381461013b57806306fdde0314610193578063095ea7b31461021057806318160ddd14610250575b600080fd5b6101436107c1565b60408051602080825283518183015283519192839290830191858101910280838360005b8381101561017f578181015183820152602001610167565b505050509050019250505060405180910390f35b61019b610823565b6040805160208082528351818301528351919283929083019185019080838360005b838110156101d55781810151838201526020016101bd565b50505050905090810190601f1680156102025780820380516001836020036101000a031916815260200191505b509250505060405180910390f35b61023c6004803603604081101561022657600080fd5b506001600160a01b0381351690602001356108ad565b604080519115158252519081900360200190f35b6102586108cf565b60408051918252519081900360200190f35b61023c6004803603606081101561028057600080fd5b506001600160a01b038135811691602081013590911690604001356108d5565b6102a8610a52565b6040805160ff9092168252519081900360200190f35b610258610a57565b610413600480360360a08110156102dc57600080fd5b6001600160a01b0382358116926020810135909116916040820135919081019060808101606082013564010000000081111561031757600080fd5b82018360208201111561032957600080fd5b8035906020019184600183028401116401000000008311171561034b57600080fd5b91908080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250929594936020810193503591505064010000000081111561039e57600080fd5b8201836020820111156103b057600080fd5b803590602001918460018302840111640100000000831117156103d257600080fd5b91908080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250929550610a5c945050505050565b005b6102586004803603602081101561042b57600080fd5b50356001600160a01b0316610abe565b6104136004803603602081101561045157600080fd5b50356001600160a01b0316610ad9565b61019b610c25565b6104136004803603606081101561047f57600080fd5b6001600160a01b03823516916020810135918101906060810160408201356401000000008111156104af57600080fd5b8201836020820111156104c157600080fd5b803590602001918460018302840111640100000000831117156104e357600080fd5b91908080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250929550610c86945050505050565b61023c6004803603604081101561053a57600080fd5b506001600160a01b038135169060200135610cb0565b61023c6004803603604081101561056657600080fd5b506001600160a01b0381358116916020013516610d89565b6102586004803603604081101561059457600080fd5b506001600160a01b0381358116916020013516610e2b565b610413600480360360208110156105c257600080fd5b50356001600160a01b0316610e56565b610413600480360360808110156105e857600080fd5b6001600160a01b038235169160208101359181019060608101604082013564010000000081111561061857600080fd5b82018360208201111561062a57600080fd5b8035906020019184600183028401116401000000008311171561064c57600080fd5b91908080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250929594936020810193503591505064010000000081111561069f57600080fd5b8201836020820111156106b157600080fd5b803590602001918460018302840111640100000000831117156106d357600080fd5b91908080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250929550610fa2945050505050565b6104136004803603604081101561072a57600080fd5b8135919081019060408101602082013564010000000081111561074c57600080fd5b82018360208201111561075e57600080fd5b8035906020019184600183028401116401000000008311171561078057600080fd5b91908080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250929550611000945050505050565b6060600480548060200260200160405190810160405280929190818152602001828054801561081957602002820191906000526020600020905b81546001600160a01b031681526001909101906020018083116107fb575b5050505050905090565b60028054604080516020601f60001961010060018716150201909416859004938401819004810282018101909252828152606093909290918301828280156108195780601f1061088157610100808354040283529160200191610819565b820191906000526020600020905b81548152906001019060200180831161088f57509395945050505050565b6000806108b8611026565b90506108c581858561102a565b5060019392505050565b60015490565b60006001600160a01b03831661091c5760405162461bcd60e51b8152600401808060200182810382526024815260200180611db66024913960400191505060405180910390fd5b6001600160a01b0384166109615760405162461bcd60e51b8152600401808060200182810382526026815260200180611e2f6026913960400191505060405180910390fd5b600061096b611026565b9050610999818686866040518060200160405280600081525060405180602001604052806000815250611116565b6109c581868686604051806020016040528060008152506040518060200160405280600081525061135c565b610a198582610a1486604051806060016040528060298152602001611e06602991396001600160a01b03808c166000908152600860209081526040808320938b16835292905220549190611575565b61102a565b610a47818686866040518060200160405280600081525060405180602001604052806000815250600061160c565b506001949350505050565b601290565b600190565b610a6d610a67611026565b86610d89565b610aa85760405162461bcd60e51b815260040180806020018281038252602c815260200180611dda602c913960400191505060405180910390fd5b610ab7858585858560016118aa565b5050505050565b6001600160a01b031660009081526020819052604090205490565b806001600160a01b0316610aeb611026565b6001600160a01b03161415610b315760405162461bcd60e51b8152600401808060200182810382526024815260200180611d246024913960400191505060405180910390fd5b6001600160a01b03811660009081526005602052604090205460ff1615610b945760076000610b5e611026565b6001600160a01b03908116825260208083019390935260409182016000908120918516815292529020805460ff19169055610bdb565b600160066000610ba2611026565b6001600160a01b03908116825260208083019390935260409182016000908120918616815292529020805460ff19169115159190911790555b610be3611026565b6001600160a01b0316816001600160a01b03167ff4caeb2d6ca8932a215a353d0703c326ec2d81fc68170f320eb2ab49e9df61f960405160405180910390a350565b60038054604080516020601f60026000196101006001881615020190951694909404938401819004810282018101909252828152606093909290918301828280156108195780601f1061088157610100808354040283529160200191610819565b610cab610c91611026565b8484846040518060200160405280600081525060016118aa565b505050565b60006001600160a01b038316610cf75760405162461bcd60e51b8152600401808060200182810382526024815260200180611db66024913960400191505060405180910390fd5b6000610d01611026565b9050610d2f818286866040518060200160405280600081525060405180602001604052806000815250611116565b610d5b81828686604051806020016040528060008152506040518060200160405280600081525061135c565b6108c5818286866040518060200160405280600081525060405180602001604052806000815250600061160c565b6000816001600160a01b0316836001600160a01b03161480610df457506001600160a01b03831660009081526005602052604090205460ff168015610df457506001600160a01b0380831660009081526007602090815260408083209387168352929052205460ff16155b80610e2457506001600160a01b0380831660009081526006602090815260408083209387168352929052205460ff165b9392505050565b6001600160a01b03918216600090815260086020908152604080832093909416825291909152205490565b610e5e611026565b6001600160a01b0316816001600160a01b03161415610eae5760405162461bcd60e51b8152600401808060200182810382526021815260200180611d486021913960400191505060405180910390fd5b6001600160a01b03811660009081526005602052604090205460ff1615610f1a57600160076000610edd611026565b6001600160a01b03908116825260208083019390935260409182016000908120918616815292529020805460ff1916911515919091179055610f58565b60066000610f26611026565b6001600160a01b03908116825260208083019390935260409182016000908120918516815292529020805460ff191690555b610f60611026565b6001600160a01b0316816001600160a01b03167f50546e66e5f44d728365dc3908c63bc5cfeeab470722c1677e3073a6ac294aa160405160405180910390a350565b610fb3610fad611026565b85610d89565b610fee5760405162461bcd60e51b815260040180806020018281038252602c815260200180611dda602c913960400191505060405180910390fd5b610ffa84848484611981565b50505050565b61102261100b611026565b838360405180602001604052806000815250611981565b5050565b3390565b6001600160a01b03831661106f5760405162461bcd60e51b8152600401808060200182810382526025815260200180611c946025913960400191505060405180910390fd5b6001600160a01b0382166110b45760405162461bcd60e51b8152600401808060200182810382526023815260200180611e786023913960400191505060405180910390fd5b6001600160a01b03808416600081815260086020908152604080832094871680845294825291829020859055815185815291517f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b9259281900390910190a3505050565b604080517faabbb8ca0000000000000000000000000000000000000000000000000000000081526001600160a01b03871660048201527f29ddb589b1fb5fc7cf394961c1adf5f8c6454761adf795e67fe149f658abe89560248201529051600091731820a4b7618bde71dce8cdc73aab6c95905fad249163aabbb8ca91604480820192602092909190829003018186803b1580156111b357600080fd5b505afa1580156111c7573d6000803e3d6000fd5b505050506040513d60208110156111dd57600080fd5b505190506001600160a01b0381161561135357806001600160a01b03166375ab97828888888888886040518763ffffffff1660e01b815260040180876001600160a01b03168152602001866001600160a01b03168152602001856001600160a01b031681526020018481526020018060200180602001838103835285818151815260200191508051906020019080838360005b83811015611288578181015183820152602001611270565b50505050905090810190601f1680156112b55780820380516001836020036101000a031916815260200191505b50838103825284518152845160209182019186019080838360005b838110156112e85781810151838201526020016112d0565b50505050905090810190601f1680156113155780820380516001836020036101000a031916815260200191505b5098505050505050505050600060405180830381600087803b15801561133a57600080fd5b505af115801561134e573d6000803e3d6000fd5b505050505b50505050505050565b61136886868686610ffa565b6113a583604051806060016040528060278152602001611cdb602791396001600160a01b0388166000908152602081905260409020549190611575565b6001600160a01b0380871660009081526020819052604080822093909355908616815220546113d49084611bbb565b600080866001600160a01b03166001600160a01b0316815260200190815260200160002081905550836001600160a01b0316856001600160a01b0316876001600160a01b03167f06b541ddaa720db2b10a4d0cdac39b8d360425fc073085fac19bc82614677987868686604051808481526020018060200180602001838103835285818151815260200191508051906020019080838360005b8381101561148557818101518382015260200161146d565b50505050905090810190601f1680156114b25780820380516001836020036101000a031916815260200191505b50838103825284518152845160209182019186019080838360005b838110156114e55781810151838201526020016114cd565b50505050905090810190601f1680156115125780820380516001836020036101000a031916815260200191505b509550505050505060405180910390a4836001600160a01b0316856001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef856040518082815260200191505060405180910390a3505050505050565b600081848411156116045760405162461bcd60e51b81526004018080602001828103825283818151815260200191508051906020019080838360005b838110156115c95781810151838201526020016115b1565b50505050905090810190601f1680156115f65780820380516001836020036101000a031916815260200191505b509250505060405180910390fd5b505050900390565b604080517faabbb8ca0000000000000000000000000000000000000000000000000000000081526001600160a01b03871660048201527fb281fc8c12954d22544db45de3159a39272895b169a852b314f9cc762e44c53b60248201529051600091731820a4b7618bde71dce8cdc73aab6c95905fad249163aabbb8ca91604480820192602092909190829003018186803b1580156116a957600080fd5b505afa1580156116bd573d6000803e3d6000fd5b505050506040513d60208110156116d357600080fd5b505190506001600160a01b0381161561184c57806001600160a01b03166223de298989898989896040518763ffffffff1660e01b815260040180876001600160a01b03168152602001866001600160a01b03168152602001856001600160a01b031681526020018481526020018060200180602001838103835285818151815260200191508051906020019080838360005b8381101561177d578181015183820152602001611765565b50505050905090810190601f1680156117aa5780820380516001836020036101000a031916815260200191505b50838103825284518152845160209182019186019080838360005b838110156117dd5781810151838201526020016117c5565b50505050905090810190601f16801561180a5780820380516001836020036101000a031916815260200191505b5098505050505050505050600060405180830381600087803b15801561182f57600080fd5b505af1158015611843573d6000803e3d6000fd5b505050506118a0565b81156118a057611864866001600160a01b0316611c15565b156118a05760405162461bcd60e51b815260040180806020018281038252604d815260200180611d69604d913960600191505060405180910390fd5b5050505050505050565b6001600160a01b0386166118ef5760405162461bcd60e51b8152600401808060200182810382526022815260200180611cb96022913960400191505060405180910390fd5b6001600160a01b03851661194a576040805162461bcd60e51b815260206004820181905260248201527f4552433737373a2073656e6420746f20746865207a65726f2061646472657373604482015290519081900360640190fd5b6000611954611026565b9050611964818888888888611116565b61197281888888888861135c565b6113538188888888888861160c565b6001600160a01b0384166119c65760405162461bcd60e51b8152600401808060200182810382526022815260200180611d026022913960400191505060405180910390fd5b60006119d0611026565b90506119df8186600087610ffa565b6119ee81866000878787611116565b611a2b84604051806060016040528060238152602001611e55602391396001600160a01b0388166000908152602081905260409020549190611575565b6001600160a01b038616600090815260208190526040902055600154611a519085611c51565b600181905550846001600160a01b0316816001600160a01b03167fa78a9be3a7b862d26933ad85fb11d80ef66b8f972d7cbba06621d583943a4098868686604051808481526020018060200180602001838103835285818151815260200191508051906020019080838360005b83811015611ad6578181015183820152602001611abe565b50505050905090810190601f168015611b035780820380516001836020036101000a031916815260200191505b50838103825284518152845160209182019186019080838360005b83811015611b36578181015183820152602001611b1e565b50505050905090810190601f168015611b635780820380516001836020036101000a031916815260200191505b509550505050505060405180910390a36040805185815290516000916001600160a01b038816917fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef9181900360200190a35050505050565b600082820183811015610e24576040805162461bcd60e51b815260206004820152601b60248201527f536166654d6174683a206164646974696f6e206f766572666c6f770000000000604482015290519081900360640190fd5b6000813f7fc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470818114801590611c4957508115155b949350505050565b6000610e2483836040518060400160405280601e81526020017f536166654d6174683a207375627472616374696f6e206f766572666c6f77000081525061157556fe4552433737373a20617070726f76652066726f6d20746865207a65726f20616464726573734552433737373a2073656e642066726f6d20746865207a65726f20616464726573734552433737373a207472616e7366657220616d6f756e7420657863656564732062616c616e63654552433737373a206275726e2066726f6d20746865207a65726f20616464726573734552433737373a20617574686f72697a696e672073656c66206173206f70657261746f724552433737373a207265766f6b696e672073656c66206173206f70657261746f724552433737373a20746f6b656e20726563697069656e7420636f6e747261637420686173206e6f20696d706c656d656e74657220666f7220455243373737546f6b656e73526563697069656e744552433737373a207472616e7366657220746f20746865207a65726f20616464726573734552433737373a2063616c6c6572206973206e6f7420616e206f70657261746f7220666f7220686f6c6465724552433737373a207472616e7366657220616d6f756e74206578636565647320616c6c6f77616e63654552433737373a207472616e736665722066726f6d20746865207a65726f20616464726573734552433737373a206275726e20616d6f756e7420657863656564732062616c616e63654552433737373a20617070726f766520746f20746865207a65726f2061646472657373a2646970667358221220c4d886431d601e1fe0e61ba6183f1c3a900c42831ac1054106ca4719248631b064736f6c63430007040033';
//# sourceMappingURL=Erc777Factory.js.map